import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
// @ts-ignore
var ga = window.ga;
var analyticsService = {
    initialize: function (appId) {
        ga('require', 'ecommerce');
    },
    sendEvent: function (eventPayload) {
        ga('send', 'event', eventPayload);
    },
    trackEvent: function (category, action, label) {
        analyticsService.sendEvent({
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
        });
    },
    trackPageView: function (page) {
        ga('set', 'page', page);
        ga('send', 'pageview');
    },
    trackLoginPage: function () {
        analyticsService.trackPageView('/login');
    },
    trackLoginPinPage: function () {
        analyticsService.trackPageView('/login-pin');
    },
    trackLoginSuccessPage: function () {
        analyticsService.trackPageView('/login-success');
    },
    trackLoginFailurePage: function () {
        analyticsService.trackPageView('/login-failure');
    },
    trackInitialSetupPage: function () {
        analyticsService.trackPageView('/initial-setup');
    },
    trackStoreLocatorPage: function () {
        analyticsService.trackPageView('/store-locator');
    },
    trackLocatorSearch: function (address, lat, lng) {
        var eventLabel = address + " - " + lat + " - " + lng;
        analyticsService.trackEvent('Location', 'Search', eventLabel);
    },
    trackStoreTransfer: function (id, name) {
        var eventLabel = name + " - " + id;
        analyticsService.trackEvent('Location', 'Transfer', eventLabel);
    },
    trackLogin: function (userId) {
        analyticsService.trackEvent('Login', 'Success', userId);
    },
    trackLoginFailure: function (phone) {
        analyticsService.trackEvent('Login', 'Failure', phone);
    },
    trackLogout: function (userId) {
        analyticsService.trackEvent('Logout', 'Success', userId);
    },
    trackUserProfileUpdate: function (customer) {
        var email = customer.email;
        var firstName = customer.firstName;
        var lastName = customer.lastName;
        var fullName = firstName + " " + lastName;
        var phone = customer.phone;
        var userChangesEventLabel = "email: " + email + " - name: " + fullName + " - phone: " + phone;
        analyticsService.trackEvent('User', 'Profile Update', userChangesEventLabel);
    },
    trackUserAddressAdd: function (address) {
        analyticsService.trackEvent('User', 'Address Add', address);
    },
    trackUserAddressSet: function (address) {
        analyticsService.trackEvent('User', 'Address Set', address);
    },
    trackUserAddressRemove: function (address) {
        analyticsService.trackEvent('User', 'Address Remove', address);
    },
    trackUserPayment: function (payment, action) {
        var accountNumber = payment.accountNumber;
        var paymentId = payment.id;
        var paymentEventLabel = accountNumber + " - " + paymentId;
        switch (action) {
            case 'Add':
                analyticsService.trackUserPaymentAdd(paymentEventLabel);
                break;
            case 'Set':
                analyticsService.trackUserPaymentSet(paymentEventLabel);
                break;
            case 'Remove':
                analyticsService.trackUserPaymentRemove(paymentEventLabel);
                break;
            default:
                break;
        }
        ;
    },
    trackUserPaymentAdd: function (payment) {
        analyticsService.trackEvent('User', 'Payment Add', payment);
    },
    trackUserPaymentSet: function (payment) {
        analyticsService.trackEvent('User', 'Payment Set', payment);
    },
    trackUserPaymentRemove: function (payment) {
        analyticsService.trackEvent('User', 'Payment Removed', payment);
    },
    trackUserAddressRemoveFailure: function (address) {
        analyticsService.trackEvent('User', 'Address Remove (Failure)', address);
    },
    trackCheckoutServiceType: function (type) {
        var serviceName = '';
        switch (type) {
            case EServiceType.SERVICE_TYPE_TAKEOUT:
                serviceName = 'Pickup';
                break;
            case EServiceType.SERVICE_TYPE_DELIVERY:
                serviceName = 'Delivery';
                break;
            default:
                serviceName = 'Takeout';
                break;
        }
        ;
        analyticsService.trackEvent('Checkout', 'Service Type', serviceName);
    },
    trackCheckoutPaymentMethod: function (method) {
        analyticsService.trackEvent('Checkout', 'Payment Method', method);
    },
    trackCheckoutSchedule: function (time) {
        var scheduled = new Date(time);
        var now = new Date();
        var deltaValue = scheduled.getTime() - now.getTime();
        var minDivisor = 216000;
        var deltaTime = Math.round(deltaValue / minDivisor);
        var eventLabel = scheduled + " - delay " + deltaTime + " min";
        if (deltaTime < 5) {
            eventLabel = scheduled + " - ASAP";
        }
        analyticsService.trackEvent('Checkout', 'Schedule', eventLabel);
    },
    trackCheckoutOrderPage: function () {
        analyticsService.trackPageView('/order');
    },
    trackCheckoutItem: function (item, transactionId) {
        ga('ecommerce:addItem', this.getTrackingItem(item, transactionId));
    },
    getTrackingItem: function (item, transactionId) {
        var price = item.getSingleItemDisplayPrice();
        return {
            id: transactionId,
            name: item.name,
            sku: item.id,
            category: item.categoryId,
            price: price,
            quantity: item.quantity,
        };
    },
    trackCheckoutTransaction: function (order) {
        var transactionId = order.id;
        var total = order.totals.sub_total / 100;
        var discount = order.totals.discount / 100;
        var revenue = (total - discount).toString();
        var formattedRevenue = parseFloat(revenue).toFixed(2);
        var shipping = order.totals.service_charge / 100;
        if (isNaN(shipping) || !shipping) {
            shipping = 0;
        }
        var tax = order.totals.tax / 100;
        ga('ecommerce:addTransaction', {
            id: transactionId,
            revenue: formattedRevenue,
            shipping: shipping,
            tax: tax,
        });
    },
    trackCheckoutSendTransaction: function () {
        ga('ecommerce:send');
    },
    trackCheckoutClearTransaction: function () {
        ga('ecommerce:clear');
    },
    trackCartAddItem: function (name) {
        analyticsService.trackPageView('/add-item');
        analyticsService.trackEvent('Cart', 'Add', name);
    },
    trackCartEditItem: function (name) {
        analyticsService.trackPageView('/edit-item');
        analyticsService.trackEvent('Cart', 'Edit', name);
    },
    trackCartUpsell: function (name) {
        analyticsService.trackPageView('/upsell-item');
        analyticsService.trackEvent('Cart', 'Upsell', name);
    },
    trackCartRemoveItem: function (name) {
        analyticsService.trackPageView('/remove-item');
        analyticsService.trackEvent('Cart', 'Remove', name);
    },
    trackCartAddRecentOrderItems: function (items) {
        var itemString = items.join(', ');
        analyticsService.trackEvent('Cart', 'Add Recent Order', itemString);
    },
    trackUpsellPage: function () {
        analyticsService.trackPageView('/recommended-items');
    },
    trackOrderCoupon: function (code) {
        analyticsService.trackEvent('Order', 'Coupon', code);
    },
    trackOrderOffer: function (rewardId) {
        analyticsService.trackEvent('Order', 'Offer', rewardId);
    },
    trackOrderSuccess: function (orderId) {
        analyticsService.trackPageView('/order-success');
        analyticsService.trackEvent('Order', 'Success', orderId);
    },
    trackOrderFailure: function (error) {
        analyticsService.trackPageView('/order-failure');
        analyticsService.trackEvent('Order', 'Failure', error);
    },
    trackOrderError: function (error) {
        analyticsService.trackPageView('/order-error');
        analyticsService.trackEvent('Order', 'Error', error);
    }
};
export default analyticsService;



//////////////////
// WEBPACK FOOTER
// ./src/services/analytics.service.ts
// module id = null
// module chunks = 